export const showLocalPickupBanner = true;
export const groupCategories = false; // true = alphabetical order, false = "Product" and "Clearance" at bottom of "Categories"

// Font selection: 'arial' | 'sf' | 'helvetica' | 'inter'
export const fontChoice = 'inter';

// Auth label: 'Sign In' or 'Log In'
export const AUTH_ACTION_LABEL = 'Log In';
